import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Delete, Pencil, Rocket} from "lucide-react";
import {useActions} from "../../app_context";
import useModal from "../../modals";
import useFeedback from "../../utils/use_feedback";
import {useDelete} from "../../api/delete";
import EditComment from "../../modals/edit_comment";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const CommentManageSheet = styled(({className, commentId, onClose}) => {

    const actions = useActions();
    const modal = useModal();
    const {feedbackCh} = useFeedback(true);
    const _delete = useDelete(feedbackCh);

    const handleEdit = () => {

        modal.open('EditComment', {commentId});
        onClose();

    };

    const handleDelete = async () => {
        onClose();
        const action = actions.commentDeleted(commentId);
        try {
            await _delete(commentId, 'comment');
        } catch {
            action.undo?.();
        }
    };

    return (
        <div className={className}>
            <MenuItem onClick={handleEdit}>
                <MenuItemIcon>
                    <Pencil size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Edit
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleDelete}>
                <MenuItemIcon>
                    <Delete size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Delete
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default CommentManageSheet;
